import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/global-board/images/empty-placeholder.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-col justify-center items-center h-full min-h-screen" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col w-full bg-background animate__animated animate__fadeIn animate__delay-0.4s min-h-screen"
}
const _hoisted_4 = { class: "flex flex-col justify-between items-center py-5" }
const _hoisted_5 = { class: "flex flex-col lg:flex-row px-4 justify-center items-center space-y-3 lg:space-y-0" }
const _hoisted_6 = { class: "lg:w-full flex lg:flex-row flex-col w-full lg:bg-white space-y-3 lg:space-y-0 rounded-lg lg:shadow-xl" }
const _hoisted_7 = { class: "flex flex-row w-full lg:w-4/12 shadow-sm lg:shadow-none rounded-lg" }
const _hoisted_8 = { class: "flex flex-row w-full lg:w-4/12 shadow-sm lg:rounded-none lg:shadow-none rounded-lg lg:border-l-2" }
const _hoisted_9 = { class: "w-full flex flex-col lg:w-3/12 justify-start items-start p-4 bg-white rounded-lg shadow-sm lg:shadow-none lg:rounded-none lg:border-l-2" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "w-full flex flex-col lg:w-4/12 px-5 items-center justify-between lg:border-l-2 relative bg-white p-4 shadow-sm lg:shadow-none lg:rounded-none lg:rounded-r-lg rounded-lg cursor-pointer" }
const _hoisted_12 = {
  ref: "modal",
  class: "bg-white rounded-lg absolute mt-11 w-full z-50 lg:p-2 transition ease-in-out shadow-2xl"
}
const _hoisted_13 = { class: "w-full p-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "lg:text-base text-sm font-semibold text-purple-500" }, "Select salary range", -1)
const _hoisted_15 = { class: "flex flex-row justify-between items-end space-x-1 mt-2" }
const _hoisted_16 = { class: "w-full flex flex-col" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "Min:", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_19 = { class: "w-full flex flex-col" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "Max:", -1)
const _hoisted_21 = {
  key: 0,
  class: "w-full"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-400 text-center w-full" }, "Max field should be greater than min", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "border mt-2 p-2 rounded-lg" }
const _hoisted_25 = { class: "w-full mt-2 flex flex-row justify-end items-end space-x-1" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "Clear", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "Apply", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "w-full flex lg:flex-row flex-col p-4 lg:space-y-0 space-y-2 lg:space-x-8 lg:mt-8 -mt-8" }
const _hoisted_31 = { class: "lg:w-3/12 py-2 lg:visible invisible h-0 lg:h-full" }
const _hoisted_32 = { class: "bg-white shadow-card w-full rounded-lg" }
const _hoisted_33 = { class: "w-full p-8" }
const _hoisted_34 = { class: "w-full mb-8 flex flex-row justify-between items-center" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium text-purple-500" }, "Clear filters", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "mt-6" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-gray-700" }, "Department", -1)
const _hoisted_39 = { class: "flex flex-col mt-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-100 py-2" }, null, -1)
const _hoisted_41 = { class: "mt-6" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-gray-700" }, "Work type", -1)
const _hoisted_43 = { class: "flex flex-col mt-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-100 py-2" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-gray-700" }, "Seniority", -1)
const _hoisted_46 = { class: "flex flex-col mt-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-100 py-2" }, null, -1)
const _hoisted_48 = { class: "w-full lg:w-9/12" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "grid lg:grid-cols-3 lg:gap-3 items-center w-full md:grid-cols-2 md:gap-2 sm:grid-cols-2 sm:gap-2 xs:grid-cols-2 xs:gap-2 animate__animated animate__fadeIn animate__delay-0.4s" }
const _hoisted_52 = { class: "" }
const _hoisted_53 = {
  key: 1,
  class: "w-full h-9/12 flex flex-col justify-center items-center min-h-fit animate__animated animate__fadeIn animate__delay-0.4s p-12"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "no results",
  width: "400"
}, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl md:text-3xl lg:text-5xl font-extrabold text-purple-300" }, "No results found")
], -1)
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "grid lg:grid-cols-3 lg:gap-3 items-center w-full md:grid-cols-2 md:gap-2 sm:grid-cols-2 sm:gap-2 xs:grid-cols-2 xs:gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_CustomSearch = _resolveComponent("CustomSearch")!
  const _component_CurrencyField = _resolveComponent("CurrencyField")!
  const _component_SimpleSelect = _resolveComponent("SimpleSelect")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_BoardCard = _resolveComponent("BoardCard")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_SkeletonCard = _resolveComponent("SkeletonCard")!
  const _component_PoweredByFooter = _resolveComponent("PoweredByFooter")!

  return (_ctx.isLoadingPage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Loader)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_Navbar),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", {
            class: _normalizeClass(["lg:text-3xl sm:text-2xl xs:text-base text-primary font-bold", _ctx.branding.accentColor])
          }, " Job Openings ", 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_CustomSearch, {
                modelValue: _ctx.inputJobValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputJobValue) = $event)),
                class: "bg-white",
                placeholder: "Search job",
                onOnSubmit: _ctx.searchByJob
              }, null, 8, ["modelValue", "onOnSubmit"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_CustomSearch, {
                modelValue: _ctx.inputLocationValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputLocationValue) = $event)),
                class: "bg-white",
                icon: "pin",
                placeholder: "Search location",
                onOnSubmit: _ctx.searchByLocation
              }, null, 8, ["modelValue", "onOnSubmit"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: "styled-checkbox",
                id: "remoteJob",
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.remoteJob) = $event)),
                value: _ctx.remoteJob
              }, null, 8, _hoisted_10), [
                [_vModelCheckbox, _ctx.remoteJob]
              ]),
              _createElementVNode("label", {
                class: _normalizeClass(["text-base font-medium text-gray-400", _ctx.branding.borderAccentColor]),
                for: "remoteJob"
              }, "Remote only", 2)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "w-full flex flex-row items-center justify-between",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expand.salary = !_ctx.expand.salary))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["text-base font-medium", [
                _ctx.isFilterbySalary
                  ? 'text-purple-600 font-semibold'
                  : 'text-gray-400',
              ]])
                }, _toDisplayString(_ctx.isFilterbySalary ? _ctx.salarySearch : "Salary Range"), 3),
                _createElementVNode("i", {
                  class: _normalizeClass(["fas fa-chevron-down text-gray-500 cursor-pointer text-primary", 
                _ctx.expand.salary && 'transform rotate-180 delay-150 ease-in-out'
              ])
                }, null, 2)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_CurrencyField, {
                        modelValue: _ctx.salaryMin,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.salaryMin) = $event)),
                        label: "",
                        name: "salaryMin",
                        board: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createVNode(_component_CurrencyField, {
                        modelValue: _ctx.salaryMax,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.salaryMax) = $event)),
                        label: "",
                        name: "salaryMax",
                        board: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  (_ctx.salaryError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_SimpleSelect, {
                      options: _ctx.optionCurrencies,
                      modelValue: _ctx.currecySalary,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currecySalary) = $event)),
                      label: "Select currency",
                      name: "currency"
                    }, null, 8, ["options", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    (_ctx.isFilterbySalary)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearSalaryRange && _ctx.clearSalaryRange(...args))),
                          class: "border border-primary px-5 py-2 rounded-lg text-primary rounded-full"
                        }, _hoisted_27))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.searchBySalary && _ctx.searchBySalary(...args))),
                      class: "border border-primary bg-primary px-5 py-2 rounded-lg text-white rounded-full"
                    }, _hoisted_29)
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.expand.salary]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["font-semibold text-xl text-primary", _ctx.branding.accentColor])
                  }, "Filters", 2),
                  (_ctx.isFilterClear)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "px-3 py-1 rounded-sm bg-gray-50",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                      }, _hoisted_36))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.expand.department = !_ctx.expand.department)),
                    class: "flex flex-row justify-between items-center w-full"
                  }, [
                    _hoisted_38,
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-chevron-down text-gray-500 cursor-pointer", 
                    _ctx.expand.department &&
                    'transform rotate-180 delay-150 ease-in-out'
                  ])
                    }, null, 2)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_39, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionDepartament, (item, index) => {
                      return (_openBlock(), _createBlock(_component_RadioButton, {
                        key: `radio-${item}-${index}`,
                        label: item.name,
                        value: item.id,
                        modelValue: _ctx.RadioDepartment,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.RadioDepartment) = $event)),
                        hasCounter: false
                      }, null, 8, ["label", "value", "modelValue"]))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.expand.department]
                  ])
                ]),
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.expand.work_type = !_ctx.expand.work_type)),
                    class: "flex flex-row justify-between items-center w-full"
                  }, [
                    _hoisted_42,
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-chevron-down text-gray-500 cursor-pointer", 
                    _ctx.expand.work_type &&
                    'transform rotate-180 delay-150 ease-in-out'
                  ])
                    }, null, 2)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsEmployment, (item, index) => {
                      return (_openBlock(), _createBlock(_component_RadioButton, {
                        key: `radio-${item}-${index}`,
                        label: item.name,
                        value: item.id,
                        modelValue: _ctx.work_type,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.work_type) = $event)),
                        hasCounter: false
                      }, null, 8, ["label", "value", "modelValue"]))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.expand.work_type]
                  ])
                ]),
                _hoisted_44,
                _createElementVNode("div", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.expand.seniority = !_ctx.expand.seniority)),
                  class: "flex flex-row justify-between items-center w-full mt-6"
                }, [
                  _hoisted_45,
                  _createElementVNode("i", {
                    class: _normalizeClass(["fas fa-chevron-down text-gray-500 cursor-pointer", 
                  _ctx.expand.seniority &&
                  'transform rotate-180 delay-150 ease-in-out'
                ])
                  }, null, 2)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_46, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsExperience, (item, index) => {
                    return (_openBlock(), _createBlock(_component_RadioButton, {
                      key: `radio-${item}-${index}`,
                      label: item.name,
                      value: item.id,
                      modelValue: _ctx.radioSeniority,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.radioSeniority) = $event)),
                      hasCounter: false
                    }, null, 8, ["label", "value", "modelValue"]))
                  }), 128))
                ], 512), [
                  [_vShow, _ctx.expand.seniority]
                ]),
                _hoisted_47
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            (!_ctx.isLoadingJobs)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  (_ctx.jobOpenings.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_BoardCard, { jobs: _ctx.jobOpenings }, null, 8, ["jobs"])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_Paginator, {
                            modelValue: _ctx.page,
                            page: _ctx.page,
                            pages: _ctx.pagination?.total_pages,
                            "range-size": 1,
                            "onUpdate:modelValue": _ctx.updateHandler,
                            total: _ctx.pagination?.total_count,
                            from: _ctx.pagination?.from,
                            to: _ctx.pagination?.to,
                            class: "mt-8"
                          }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_56))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], (item, index) => {
                      return _createElementVNode("div", { key: index }, [
                        _createVNode(_component_SkeletonCard)
                      ])
                    }), 64))
                  ])
                ]))
          ])
        ]),
        _createVNode(_component_PoweredByFooter)
      ]))
}